export default [
  {
    path: '/vinculo-acompanhamento',
    component: () => import('@/pages/VinculoAcompanhamento/Index.vue'),
  },
  {
    path: '/vinculo-acompanhamento/cadastros-individuais',
    component: () =>
      import('@/pages/VinculoAcompanhamento/CadastrosIndividuais/Template.vue'),
    children: [
      {
        path: '/vinculo-acompanhamento/cadastros-individuais/acs',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/CadastrosIndividuais/CadastrosIndividuais.vue'
          ),
      },
      {
        path: '/vinculo-acompanhamento/cadastros-individuais/profissional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/CadastrosIndividuais/PorAcs.vue'
          ),
      },
      {
        path: '/vinculo-acompanhamento/cadastros-individuais/equipe/acs',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/CadastrosIndividuais/PorEquipeAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/vinculo-acompanhamento/acompanhamento',
    component: () =>
      import('@/pages/VinculoAcompanhamento/Acompanhamento/Template.vue'),
    children: [
      {
        path: '/vinculo-acompanhamento/acompanhamento',
        component: () =>
          import('@/pages/VinculoAcompanhamento/Acompanhamento/Index.vue'),
      },
    ],
  },
  {
    path: '/vinculo-acompanhamento/diagnostico-situacional',
    component: () =>
      import(
        '@/pages/VinculoAcompanhamento/DiagnosticoSituacional/Template.vue'
      ),
    children: [
      {
        path: '/vinculo-acompanhamento/diagnostico-situacional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/DiagnosticoSituacional/Index.vue'
          ),
      },
    ],
  },
  {
    path: '/vinculo-acompanhamento/recursos',
    component: () => import('@/pages/VinculoAcompanhamento/Recursos/Index.vue'),
  },
  {
    path: '/vinculo-acompanhamento/agenda-por-profissional',
    component: () =>
      import(
        '@/pages/VinculoAcompanhamento/AgendaPorProfissional/Template.vue'
      ),
    children: [
      {
        path: '/vinculo-acompanhamento/agenda-por-profissional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/Index.vue'
          ),
      },
      {
        path: '/vinculo-acompanhamento/agenda-por-profissional/equipe/acs',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/PorEquipeAcs.vue'
          ),
      },
      {
        path: '/vinculo-acompanhamento/agenda-por-profissional/profissional',
        component: () =>
          import(
            '@/pages/VinculoAcompanhamento/AgendaPorProfissional/PorAcs.vue'
          ),
      },
    ],
  },
  {
    path: '/vinculo-acompanhamento/avaliacao-atendimentos',
    component: () =>
      import('@/pages/VinculoAcompanhamento/AvaliacaoAtendimentos/Index.vue'),
  },
  {
    path: '/vinculo-acompanhamento/condicoes-saude',
    component: () =>
      import('@/pages/VinculoAcompanhamento/CondicoesSaude/Template.vue'),
    children: [
      {
        path: '/vinculo-acompanhamento/condicoes-saude',
        component: () =>
          import('@/pages/VinculoAcompanhamento/CondicoesSaude/Index.vue'),
      },
    ],
  },
]
